// Procurement V2 feature flag. Defaults ON for the three procurement roles so
// the new role-gated functionality is available out of the box; an env var can
// force it off without code changes.
//
// Gating is still enforced per-role via the menu registry / eligibleRoles; this
// flag is an extra global kill-switch only.
export const isProcurementV2Enabled = () =>
  process.env.REACT_APP_ENABLE_PROCUREMENT_V2 !== "false"
